import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { ContentRoute } from '../_metronic/layout'
import AdminsPage from './modules/ContentManager/admins/AdminsPage'
import EditAdminsPage from './modules/ContentManager/admins/EditAdminsPage'
import EditRegattasPage from './modules/ContentManager/regattas/EditRegattasPage'
import RegattasPage from './modules/ContentManager/regattas/RegattasPage'
import RankingRegattasPage from './modules/ContentManager/regattas/RankingRegattasPage'
import EditClubsPage from './modules/ContentManager/clubs/EditClubsPage'
import ClubsPage from './modules/ContentManager/clubs/ClubsPage'
import ContractsPage from './modules/ContentManager/contracts/ContractsPage'
import EditContractsPage from './modules/ContentManager/contracts/EditContractsPage'
import AltaClubPage from './modules/ContentManager/contracts/AltaClubPage'
import TarifasPage from './modules/ContentManager/contracts/TarifasPage'
import EditGpsDevicesPage from './modules/ContentManager/gpsdevices/EditGpsDevicesPage'
import GpsDevicesPage from './modules/ContentManager/gpsdevices/GpsDevicesPage'
import EditBoatsPage from './modules/ContentManager/boats/EditBoatsPage'
import BoatsPage from './modules/ContentManager/boats/BoatsPage'
import EditSailorsPage from './modules/ContentManager/sailors/EditSailorsPage'
import SailorsPage from './modules/ContentManager/sailors/SailorsPage'
import EditBoatTypesPage from './modules/ContentManager/boattypes/EditBoatTypesPage'
import BoatTypesPage from './modules/ContentManager/boattypes/BoatTypesPage'
import QuizzesPage from './modules/ContentManager/quizzes/QuizzesPage'
import ViewQuizPage from './modules/ContentManager/quizzes/ViewQuizPage'
import ScenesPage from './modules/ContentManager/scenes/ScenesPage'
import ViewScenePage from './modules/ContentManager/scenes/ViewScenePage'
import EditArticlesPage from './modules/ContentManager/articles/EditArticlesPage'
import ArticlesPage from './modules/ContentManager/articles/ArticlesPage'
import LegalPage from './modules/ContentManager/legal/LegalPage'
import EditLegalPage from './modules/ContentManager/legal/EditLegalPage'
import { DashboardPage } from './pages/DashboardPage'
import { ResultsPage } from './pages/ResultsPage'

export default function BasePage() {
	return (
		<Switch>
			{/* Redirect from root URL to /dashboard. */}
			<Redirect exact from="/" to="/dashboard" />
			<ContentRoute path="/dashboard" component={DashboardPage} />
			<ContentRoute path="/results" component={ResultsPage} />
			{/* Administrators */}
			<ContentRoute from="/admins" component={AdminsPage} />
			<ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />
			{/* Boats */}
			<ContentRoute from="/boats" component={BoatsPage} />
			<ContentRoute from="/edit-boat/:id?" component={EditBoatsPage} />
			{/* Articles */}
			<ContentRoute from="/articles" component={ArticlesPage} />
			<ContentRoute from="/edit-article/:id?" component={EditArticlesPage} />
			{/* Textos legales: solo se editan, no se crean ni se borran */}
			<ContentRoute from="/legal" component={LegalPage} />
			<ContentRoute from="/edit-legal/:clave/:idioma" component={EditLegalPage} />
			{/* Regattas */}
			<ContentRoute from="/regattas" component={RegattasPage} />
			<ContentRoute from="/edit-regatta/:id?" component={EditRegattasPage} />
			<ContentRoute
				from="/ranking-regatta/:id?"
				component={RankingRegattasPage}
			/>
			{/* Clubs */}
			<ContentRoute from="/clubs" component={ClubsPage} />
			<ContentRoute from="/edit-club/:id?" component={EditClubsPage} />
			{/* Contratos y alta de clubes */}
			<ContentRoute from="/contracts" component={ContractsPage} />
			<ContentRoute from="/edit-contract/:id" component={EditContractsPage} />
			<ContentRoute from="/alta-club" component={AltaClubPage} />
			<ContentRoute from="/tarifas" component={TarifasPage} />
			{/* GPS Devices */}
			<ContentRoute from="/gpsdevices" component={GpsDevicesPage} />
			<ContentRoute from="/edit-gpsdevice/:id?" component={EditGpsDevicesPage} />
			{/* Sailors */}
			<ContentRoute from="/sailors" component={SailorsPage} />
			<ContentRoute
				from="/edit-sailor/:id?"
				component={EditSailorsPage}
			/>
			{/* BoatTypes */}
			<ContentRoute from="/boattypes" component={BoatTypesPage} />
			<ContentRoute from="/edit-boattype/:id?" component={EditBoatTypesPage} />
			{/* Scenes */}
			<ContentRoute from="/scenarios" component={ScenesPage} />
			<ContentRoute from="/scenario/:id" component={ViewScenePage} />
			{/* Quizzes */}
			<ContentRoute from="/quizzes" component={QuizzesPage} />
			<ContentRoute from="/quiz/:id" component={ViewQuizPage} />
			<Redirect to="/error" />
		</Switch>
	)
}
